<template>
  <div>
    <div class="top">
      <RexButtonV3 @onClick="display" variant="primary" id="btn-add-dashboard">
        {{ $t('addDashboard') }}
      </RexButtonV3>
    </div>
    <RexModalV3
      :show="modalToBeShown"
      :enableFooter="true"
      :title="isEdit ? $t('editDashboard') : $t('addDashboard')"
      @onClose="closeModal"
    >
      <template #body>
        <div
          class="grp-modal-body"
          :class="isEdit ? 'edit-height' : 'add-height'"
        >
          <div class="d-flex flex-column">
            <div class="mb-3">
              <RexModalLabel
                :primaryLabel="$t('name')"
                :secondaryLabel="$t('required')"
              />
            </div>

            <RexModalInput
              type="text"
              placeholder
              style="width: 31rem; height: 2.5em"
              v-model="dashboardName"
              id="input-dashboard-name"
            />
            <RexInfoLabel
              :isError="true"
              customStyle="width:20em; marginBottom: 0rem"
              v-if="validations"
              :info="$t('dashboardNameValidation')"
            />
          </div>
          <div class="d-flex flex-column" v-if="!isEdit">
            <div class="mb-3 mt-3">
              <RexModalLabel
                :primaryLabel="$t('copyTemplate')"
                :secondaryLabel="$t('optional')"
              />
            </div>
            <RexSearchSelect
              :data="templateData"
              :current="selectedDashboard"
              width="31rem"
              @onChoose="(item) => changeTemplate(item)"
              :searchPlaceholder="searchDashboard"
              :objectValueIndex="0"
              id="search-select-add-dashboard"
            />
          </div>
          <div v-if="getShowCapabilityField">
            <div class="cus-add-dash-label">
              <RexModalLabel
                :primaryLabel="$t('selectCapability')"
                :secondaryLabel="$t('required')"
              />
            </div>
            <RexSearchSelect
              :data="capabilityList"
              :current="selectedCapability"
              @onChoose="onCapabilityChange"
              :searchPlaceholder="$t('searchCapability')"
              id="cus-add-dash-select-capability"
              width="31rem"
            />
            <RexInfoLabel
              :isError="true"
              customStyle="width:20em"
              v-if="!!capabilityErrMsg"
              :info="capabilityErrMsg"
            />
          </div>

          <div v-if="!isEdit && showSummaryFields">
            <div class="cus-add-dash-label">
              <RexModalLabel
                :primaryLabel="$t('selectApplication')"
                :secondaryLabel="$t('required')"
              />
            </div>
            <RexSearchSelect
              :isEdit="true"
              :boldActive="true"
              :isSearch="true"
              :data="applList"
              :searchPlaceholder="$t('searchApplication')"
              :multiSelect="true"
              @onMultiSelect="onServiceChange"
              :multiSelectTitle="mulitiSelServiceLabel"
              id="cus-add-dash-select-capability-service"
              :useParentData="true"
              width="31rem"
            />
            <RexInfoLabel
              :isError="true"
              customStyle="width:20em"
              v-if="!!serviceErrMsg"
              :info="serviceErrMsg"
            />
          </div>
        </div>
      </template>

      <template #footer>
        <div class="cus-dash-modal-footer-box">
          <RexButtonV3
            variant="default"
            @onClick="onClickClear"
            id="btn-clr-dashboard"
            class="mr-4"
          >
            {{ $t('clear') }}
          </RexButtonV3>

          <RexButtonV3
            :disabled="disabled"
            variant="primary"
            @onClick="submitData"
            id="btn-submit-dashboard"
          >
            {{ isEdit ? $t('update') : $t('add') }}
          </RexButtonV3>
        </div>
      </template>
    </RexModalV3>
  </div>
</template>

<script>
import RexButtonV3 from '@/rex-components/RexButtonV3.vue';
import RexModalV3 from '@/rex-components/RexModalV3.vue';
import { mapActions, mapMutations, mapGetters } from 'vuex';
import RexModalLabel from '@/rex-components/rex-modal-label.vue';
import RexModalInput from '@/rex-components/rex-modal-input.vue';
import RexInfoLabel from '@/rex-components/rex-info-label.vue';
import RexSearchSelect from '@/rex-components/RexSearchSelect.vue';
import { CustomService } from '@/services/api/custom.service';
import { notificationSucess, notificationError } from '@/utils/notification';
import {
  metricLabels,
  APPLICATION_SUMMARY,
  VM_SUMMARY,
  summaryMetricCapabilityList,
  vmCapabilityObj,
  MAX_SERVICES_FOR_SUMMARY_METRIC,
  defaultCapabilityObj,
} from '@/components/Home/utils/custom.home.types';
import {
  CAPABILITY_APM,
  CAPABILITY_BROWSER,
  CAPABILITY_MOBILE,
  CAPABILITY_A,
  CAPABILITY_B,
  CAPABILITY_M,
  CAPABILITY_VM,
} from '@/utils/constants';
import { permissionTypes } from '@/router/constant';

// @ is an alias to /src
export default {
  name: 'DashboardModal',
  components: {
    RexButtonV3,
    RexModalV3,
    RexModalLabel,
    RexModalInput,
    RexInfoLabel,
    RexSearchSelect,
  },
  data() {
    return {
      showDelModal: false,
      isDelete: false,
      delGroupItem: {},
      active: false,
      size: '109px',
      text: '',
      dashboardName: '',
      showModal: false,
      selectedApps: [],
      validations: false,
      searchDashboard: this.$t('searchDashboard'),
      selectedDashboard: { label: 'Choose dashboard', id: '' },
      addedItem: {},
      showSummaryFields: false,
      selectedCapability: defaultCapabilityObj,
      applList: [],
      capabilityErrMsg: '',
      serviceErrMsg: '',
      disabled: true,
    };
  },

  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    editItem: {},
    selectedTemplate: {},
    templates: {},
  },
  computed: {
    ...mapGetters('browserState/browserCommonState', ['getAllBrowserServices']),
    ...mapGetters('apmState/apmCommonState', ['getServices']),
    ...mapGetters('mobileState/mobileCommonState', ['getAllMobileServices']),
    ...mapGetters('vmState/vmCommonState', ['getAllVMServices']),
    ...mapGetters('globalState/settings', ['getDurationTime']),
    modalToBeShown() {
      if (this.isEdit && !this.showModal) {
        return true;
      } else if (this.isEdit && this.showModal) {
        return true;
      } else if (!this.isEdit && this.showModal) {
        return true;
      }
      return false;
    },
    templateData() {
      var tempData = [...metricLabels];
      for (var i = 1; i < this.templates.length; i++) {
        let trans = this.templates[i];
        tempData.push(trans);
      }
      tempData = tempData.filter((e) => e.id != 'defaultBeta');
      return tempData;
    },
    mulitiSelServiceLabel() {
      let applnLen = this.applList.filter((obj) => obj.selected).length || 0;
      const applnStrKey =
        applnLen === 1
          ? 'countApplicationSelected'
          : 'countApplicationsSelected';

      return applnLen === 0
        ? this.$t('searchApplication')
        : this.$t(`${applnStrKey}`, [applnLen]);
    },
    getShowCapabilityField() {
      return (
        !this.isEdit &&
        this.showSummaryFields &&
        this.selectedDashboard?.id === APPLICATION_SUMMARY
      );
    },
    getSelectedServiceList() {
      return this.applList.filter((obj) => obj.selected);
    },
  },
  methods: {
    ...mapMutations('homeState', ['setSelectedWidgetId']),
    ...mapActions('apmState/apmCommonState', {
      getServicesAction: 'getServices',
    }),
    ...mapActions('browserState/browserCommonState', ['getBrowserData']),
    ...mapActions('mobileState/mobileCommonState', ['GET_MOBILE_SERVICES']),
    ...mapActions('vmState/vmCommonState', ['getVMData']),
    getSummaryWidgetObj() {
      const obj = {
        serviceIds: this.getSelectedServiceList.map((obj) => obj.key),
        templateName: this.selectedCapability?.key,
      };

      return this.selectedDashboard.id === APPLICATION_SUMMARY ||
        this.selectedDashboard.id === VM_SUMMARY
        ? obj
        : {};
    },
    async addDashboard() {
      try {
        const reqObj = this.getSummaryWidgetObj();

        await CustomService.addDashboard({
          ...reqObj,
          name: this.dashboardName,
        }).then((resp) => {
          if (resp.data.success) {
            // this.addedItem = resp.data.data;
            let newItem = {
              name: resp.data.data[0].name,
              id: resp.data.data[0].id,
            };
            this.addedItem = newItem;
            this.$emit('onSubmit', this.addedItem);
            this.addedItem = {};
            notificationSucess(this.$t('dashboardCreated'));
            this.setSelectedWidgetId(resp.data.data[0].id);
          }
        });
      } catch (error) {
        console.log(error);
        notificationError(
          (error.status === 400 && error?.data?.message) ||
            this.$t('errorAddingDashboard'),
        );
      }
    },
    async addDashboardFromId() {
      try {
        await CustomService.addDashboardFromId({
          name: this.dashboardName,
          id: this.selectedDashboard.id,
        }).then((resp) => {
          if (resp.data.success) {
            let newItem = {
              name: resp.data.data[0].name,
              id: resp.data.data[0].id,
            };
            this.addedItem = newItem;
            this.$emit('onSubmit', this.addedItem);
            this.addedItem = {};
            notificationSucess(this.$t('dashboardCreatedTemplate'));
            this.setSelectedWidgetId(resp.data.data[0].id);
          }
        });
      } catch (error) {
        console.log(error);
        notificationError(
          (error.status === 400 && error?.data?.message) ||
            this.$t('errorAddingDashboard'),
        );
      }
    },
    async editDashboard() {
      try {
        await CustomService.editDashboard({
          name: this.dashboardName,
          id: this.editItem.id,
        }).then((resp) => {
          if (resp.data.success) {
            let newItem = {
              name: resp.data.data[0].name,
              id: resp.data.data[0].id,
            };
            this.addedItem = newItem;
            notificationSucess(this.$t('dashboardEdited'));
          }
        });
      } catch (error) {
        console.log(error);
        notificationError(
          (error.status === 400 && error?.data?.message) ||
            this.$t('errorUpdatingDashboard'),
        );
        throw new Error(this.$t('edit-dashboard-failed'));
      }
    },
    changeTemplate(item) {
      this.selectedCapability = defaultCapabilityObj;
      this.applList = [];
      this.showSummaryFields =
        item.id === APPLICATION_SUMMARY || item.id === VM_SUMMARY;
      if (item.id === VM_SUMMARY) {
        this.onCapabilityChange(vmCapabilityObj);
      }
      this.selectedDashboard = item;
    },
    toggle() {
      this.active = !this.active;
    },

    closeModal() {
      this.showModal = false;
      this.$emit('close-modal', false);
      setTimeout(() => {
        this.onClickClear();
        this.validations = false;
      }, 100);
    },
    onClickClear() {
      this.dashboardName = '';
      this.validations = false;
      this.selectedDashboard = { label: this.$t('choose-dashboard'), id: '' };
      this.showSummaryFields = false;
      this.selectedCapability = {};
      this.applList = [];
    },
    display() {
      this.validations = false;
      this.showModal = true;
    },
    checkFormValid() {
      if (
        !this.dashboardName ||
        this.dashboardName.length > 20 ||
        !/^( )?[a-zA-Z0-9]+( [a-zA-Z0-9]+)*( )?$/.test(this.dashboardName)
      ) {
        this.validations = true;
      } else {
        this.validations = false;
      }
    },
    validateSummaryFields() {
      if (!this.showSummaryFields) return true;
      this.capabilityErrMsg =
        !this.selectedCapability?.key && this.$t('capabilityValidation');

      this.serviceErrMsg =
        this.getSelectedServiceList?.length === 0 &&
        this.$t('applicationValidation');

      return !this.capabilityErrMsg && !this.serviceErrMsg;
    },
    async submitData() {
      try {
        this.checkFormValid();
        if (
          this.validateSummaryFields() &&
          this.dashboardName.length <= 20 &&
          this.dashboardName
        ) {
          if (
            !this.isEdit &&
            (this.selectedDashboard.id === '' ||
              this.selectedDashboard.id === APPLICATION_SUMMARY ||
              this.selectedDashboard.id === VM_SUMMARY)
          ) {
            await this.addDashboard();

            this.closeModal();
          } else if (!this.isEdit && this.selectedDashboard.id != '') {
            this.addDashboardFromId();
            this.closeModal();
          } else if (this.isEdit) {
            await this.editDashboard()
              .then(() => {
                this.$emit('onSubmit', this.addedItem);
                this.addedItem = {};
              })
              .catch((err) => console.log(err));
            this.closeModal();
          }
        }
      } catch (error) {
        console.log('error', error);
      }
    },
    hide(evt) {
      if (evt.trigger === 'backdrop') {
        evt.preventDefault();
        this.closeModal();
        this.showModal = false;
      }
    },
    async onCapabilityChange(item) {
      let servList = [];
      switch (item.key) {
        case CAPABILITY_APM:
          await this.loadAPMServices();
          servList = this.getServices;
          break;
        case CAPABILITY_BROWSER:
          await this.loadBrowserServices();
          servList = this.getAllBrowserServices;
          break;
        case CAPABILITY_MOBILE:
          await this.loadMobileService();
          servList = this.getAllMobileServices;
          break;
        case CAPABILITY_VM:
          await this.loadVMServices();
          servList = this.getAllVMServices;
          break;
        default:
          break;
      }
      this.selectedCapability = item;
      this.capabilityErrMsg = '';

      this.applList = servList.map((obj) => ({
        label: obj.label,
        key: obj.key,
        selected: false,
      }));
    },
    onServiceChange(item) {
      this.serviceErrMsg = '';
      if (
        !item.selected &&
        this.getSelectedServiceList.length >= MAX_SERVICES_FOR_SUMMARY_METRIC
      ) {
        notificationError(
          this.$t('maxApplicationsCanBeSelected', [
            MAX_SERVICES_FOR_SUMMARY_METRIC,
          ]),
        );
        return;
      }

      this.applList = this.applList.map((obj) => {
        if (obj.key === item.key) obj.selected = !obj.selected;
        return obj;
      });
    },
    async loadBrowserServices() {
      try {
        await this.getBrowserData({
          duration: this.getDurationTime,
          serviceReq: { capability: CAPABILITY_B },
          permissions: [permissionTypes.WRITE],
        });
      } catch (error) {
        console.log('error', error);
      }
    },
    async loadAPMServices() {
      try {
        await this.getServicesAction({
          duration: this.getDurationTime,
          serviceReq: { capability: CAPABILITY_A },
          permissions: [permissionTypes.WRITE],
        });
      } catch (error) {
        console.log('error', error);
      }
    },
    async loadMobileService() {
      try {
        await this.GET_MOBILE_SERVICES({
          duration: this.getDurationTime,
          serviceReq: { capability: CAPABILITY_M },
          permissions: [permissionTypes.WRITE],
        });
      } catch (error) {
        console.log('error', error);
      }
    },
    async loadVMServices() {
      try {
        await this.getVMData({
          duration: this.getDurationTime,
          keyword: '',
          serviceReq: {
            capability: 'V',
          },
          permissions: [permissionTypes.WRITE],
        });
      } catch (error) {
        console.log('error', error);
      }
    },
  },
  watch: {
    isEdit() {
      if (this.isEdit) {
        this.dashboardName = this.editItem.name;
        this.dashboardId = this.editItem.id;
        this.templateName = this.editItem.name;
      }
    },
    dashboardName() {
      if (
        this.dashboardName.length > 20 ||
        !this.dashboardName ||
        !/^( )?[a-zA-Z0-9]+( [a-zA-Z0-9]+)*( )?$/.test(this.dashboardName)
      ) {
        this.disabled = true;
        this.validations = true;
      } else {
        this.disabled = false;
        this.validations = false;
      }
    },
  },

  mounted() {
    this.selectedDashboard = this.selectedTemplate;
    if (this.isEdit) {
      this.templateName = this.editItem.name;
    }
  },
  created() {
    this.capabilityList = summaryMetricCapabilityList;
  },
};
</script>
<style lang="scss" scoped>
.select {
  width: 20.75rem;
  height: 2.5rem;
  border-radius: 0.25rem;
  background-color: $font-primary;
}
.select.open {
  border-radius: 0.375rem 0.375rem 0rem 0rem;
}

.validation {
  color: $poor;
}
.grp-modal-body {
  max-width: 49.375rem;
  height: 100%;
  margin-bottom: 1rem;
}
.edit-height {
  min-height: 7.5rem;
}
.add-height {
  min-height: 14.5rem;
}
.cus-dash-modal-footer-box {
  display: flex;
  justify-content: flex-end;
}
.cus-add-dash-label {
  margin: 1rem 0rem 0.5rem 0rem;
}
</style>
